import { UMOOC_COOKIE_DOMAIN, ORG_SITE} from '@/config'
import { getOrgMenuInfo } from '@/api/courseApi'
import { buildResourcePath } from '@/utils'
export default {
  namespaced: true,
  state: {
    org: {
      isMainSite: ORG_SITE == 'umooc', // 是否是优学院主站（区分主站和二级站点）
      prefix: ORG_SITE,
      title: '',
      footer: {
        type: 0,
        list: []
      },
      logo: ''
    }
  },
  getters: {
    org (state) {
      return state.org
    }
  },
  mutations: {
    setOrg (state, org) {
      state.org.footer = org.footLinks
      state.org.logo = buildResourcePath(org.logo.imglink)
      state.org.title = org.logo.title
    },
    setOrgFooter (state, footer) {
      state.org.footer = footer
    },
    setOrglogo (state, logo) {
      state.org.logo = logo
    }
  },
  actions: {
    setOrg ({ commit }) {
      getOrgMenuInfo(ORG_SITE)
        .then(({result}) => {
          commit('setOrg', result)
          // commit('setOrgFooter', result.footLinks)
          // commit('setOrglogo', buildResourcePath(result.logo.imglink))
        })
    }
  }
}